export { default } from './AGSetList.component';
